"use strict";

export function initInScope ($scope) {
    let $tooltips = $scope.find('[data-toggle="tooltip"]');
    $tooltips.each(function () {
        $(this).tooltip();
    });
};